export const normalizeCarModelVariationItem = (
  item
) => {
  const modelVariationId =
    item.modelVariationId ??
    item.ModelVariationId;

  return {
    id:
      modelVariationId ??
      item.id ??
      item.Id,
    description:
      item.description ??
      item.Description ??
      item.arDescription ??
      item.ArDescription,
    priceListNumber:
      item.priceListNumber ??
      item.PriceListNumber,
    sellingPrice:
      item.sellingPrice ??
      item.SellingPrice,
  };
};

export const getCarModelVariationsFromCar = (
  car
) => {
  const raw =
    car?.carModelVariations ??
    car?.CarModelVariations ??
    car?.modelVariation ??
    car?.ModelVariation ??
    [];

  if (!Array.isArray(raw)) {
    return [];
  }

  return raw
    .map(normalizeCarModelVariationItem)
    .filter((item) => item.id != null);
};

export const normalizeCarForEdit = (car) => {
  if (!car) {
    return null;
  }

  const imageProfile =
    car.imageProfile &&
    !String(car.imageProfile).includes(
      "Could not find"
    )
      ? car.imageProfile
      : "";

  return {
    ...car,
    brand_id:
      car.brand_id ??
      car.brandId ??
      car.BrandId ??
      car.brand?.brand_id ??
      car.brand?.brandId ??
      car.brand?.BrandId,
    brandType_id:
      car.brandType_id ??
      car.brandTypeId ??
      car.BrandTypeId,
    modelVariation:
      getCarModelVariationsFromCar(car),
    imageProfile,
  };
};

export const EDIT_CAR_FORM_EXCLUDED_KEYS = [
  "brandType",
  "colors",
  "modelVariation",
  "carModelVariations",
  "CarModelVariations",
  "brand_types",
  "category_Option",
  "carImages",
  "brand",
  "creator_id",
  "creator_at",
  "update_Id",
  "updated_at",
  "delete_Id",
  "deleted_at",
  "allowCategories",
];

export const mapPriceItem = (item) => {
  const priceListNumber =
    item.priceListNumber ??
    item.PriceListNumber ??
    item.id ??
    item.priceId ??
    item.priceCode ??
    item.code;

  const sellingPrice =
    item.sellingPrice ??
    item.SellingPrice ??
    item.price ??
    item.amount;

  const labelParts = [
    sellingPrice != null
      ? String(sellingPrice)
      : null,
    item.arDescription ??
      item.description ??
      item.nameAr,
    item.enDescription ?? item.nameEn,
    priceListNumber != null
      ? `#${priceListNumber}`
      : null,
  ].filter(Boolean);

  return {
    value: priceListNumber,
    label:
      labelParts.join(" - ") ||
      String(priceListNumber ?? ""),
    raw: item,
  };
};

export const mergePriceOptions = (prev, next) => {
  const map = new Map(
    [...prev, ...next].map((o) => [o.value, o])
  );

  return [...map.values()];
};

export const buildSavedPriceOption = ({
  priceListNumber,
  sellingPrice,
  label,
}) => {
  if (
    priceListNumber == null &&
    sellingPrice == null
  ) {
    return null;
  }

  const labelParts = [
    sellingPrice != null
      ? String(sellingPrice)
      : null,
    label,
    priceListNumber != null
      ? `#${priceListNumber}`
      : null,
  ].filter(Boolean);

  return {
    value: priceListNumber,
    label:
      labelParts.join(" - ") ||
      String(
        priceListNumber ?? sellingPrice ?? ""
      ),
    raw: {
      priceListNumber,
      sellingPrice,
      PriceListNumber: priceListNumber,
      SellingPrice: sellingPrice,
    },
  };
};

export const getSellingPriceFromSelection = (
  selected
) => {
  const raw = selected?.raw ?? {};

  return (
    raw.sellingPrice ??
    raw.SellingPrice ??
    raw.price ??
    raw.amount
  );
};

export const appendVariationPriceToFormData = (
  formData,
  index,
  selectedPrice
) => {
  const raw = selectedPrice?.raw ?? {};

  const priceListNumber =
    raw.priceListNumber ??
    raw.PriceListNumber ??
    selectedPrice?.value;

  const sellingPrice =
    getSellingPriceFromSelection(
      selectedPrice
    );

  if (priceListNumber != null) {
    formData.append(
      `ModelVariation[${index}].priceListNumber`,
      priceListNumber
    );
  }

  if (sellingPrice != null) {
    formData.append(
      `ModelVariation[${index}].sellingPrice`,
      sellingPrice
    );
  }
};
